import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectListComponent implements OnInit {

  private _ready = false;
  private _list:Array<any> = [];
  @Input()
  public set list(l:Array<any>) {
    this._list = l;
    console.log('project list',this._list);
    this.Refresh();
  }
  public get list():Array<any> {
    return this._list;
  }

  @Output() onConfig = new EventEmitter<number>();
  @Output() onLaunch = new EventEmitter<number>();
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this._ready = true;
    this.cdr.detach();
  }
  EditConfig(projectId:number) {
    this.onConfig.emit(projectId);
  }
  LaunchMap(projectId:number) {
    this.onLaunch.emit(projectId);
  }
  Refresh() {
    this.cdr.detectChanges();
  }

}
